import { createStorageHooks } from './shared/storage';

const { useStorageValue: useLocalStorageValue, useStorageValueAsync: useLocalStorageValueAsync } = createStorageHooks(
	typeof localStorage === 'undefined' ? undefined : localStorage,
);

export { useLocalStorageValue, useLocalStorageValueAsync };
